import clsx from 'clsx';

export interface SegmentedControlOption {
  id: string;
  label: string;
}

interface SegmentedControlProps {
  options: SegmentedControlOption[];
  selectedId: string;
  onChange: (option: SegmentedControlOption) => void;
  className?: string;
  segmentClassName?: string;
  'data-testid'?: string;
}

const SegmentedControl = ({
  options,
  selectedId,
  onChange,
  className,
  segmentClassName,
  'data-testid': dataTestId
}: SegmentedControlProps) => (
  <div
    role="tablist"
    aria-orientation="horizontal"
    className={clsx(
      'inline-flex items-center gap-1 rounded-lg bg-cofeeGreyBlue2 p-1',
      className
    )}
    data-testid={dataTestId}
  >
    {options.map((option) => {
      const isActive = option.id === selectedId;
      return (
        <button
          key={option.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(option)}
          className={clsx(
            'rounded-md px-4 py-1.5 text-sm transition-colors',
            isActive
              ? 'bg-cofeeNeutral1 font-semibold text-cofeePrimary6'
              : 'font-medium text-cofeeNeutral8 hover:text-cofeeNeutral10',
            segmentClassName
          )}
          data-testid={dataTestId ? `${dataTestId}-${option.id}` : undefined}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
